import React, { Component } from 'react'
import { injectIntl } from 'react-intl'

import Icon from 'components/Icon'
import SearchIcon from 'icons/SearchIcon'
import defaultStyles from './EntityPicker.css'

const PREVENT_DEFAULT = ev => {
  ev.preventDefault()
}

const defaultCanPick = entity => true

const defaultRenderEntity = entity => <div>{entity._id}</div>

export class EntityPicker extends Component {
  constructor(props) {
    super(props)
    this.setActive = this.setActive.bind(this)
    this.setInactive = this.setInactive.bind(this)
    this.handleFilterChange = this.handleFilterChange.bind(this)
    this.handlePickEntity = this.handlePickEntity.bind(this)
    this.captureInputElement = this.captureInputElement.bind(this)
    this.state = { active: props.alwaysShowEntities || false, filter: '' }
  }
  captureInputElement(el) {
    this.el = el
  }
  handlePickEntity(entity) {
    let { onPickEntity } = this.props
    if (onPickEntity) {
      onPickEntity(entity)
    }
    if (this.el) {
      this.el.blur()
    }
  }
  setActive() {
    this.setState({
      active: true
    })
  }
  setInactive() {
    const { clearSuggestions, alwaysShowEntities } = this.props
    if (!alwaysShowEntities) {
      clearSuggestions()
      this.setState({
        active: false
      })
    }
  }
  handleFilterChange(ev) {
    if (ev && ev.stopPropagation) {
      ev.stopPropagation()
      ev.preventDefault()
    }
    const { clearSuggestions, getSuggestions, onChange } = this.props
    const filter = ev.target.value
    if (filter && filter.trim().length) {
      getSuggestions({
        filter: encodeURIComponent(filter)
      })
    } else {
      clearSuggestions()
    }
    onChange && onChange(ev)
  }
  render() {
    const {
      pickerInputMessageId,
      classes,
      className,
      entityTypeName,
      onPickEntity,
      suggestions = [],
      blacklist = [],
      intl,
      canPick = defaultCanPick,
      renderEntity = defaultRenderEntity,
      searchIcon = SearchIcon,
      value,
      alwaysShowEntities,
      maxLength = 30
    } = this.props

    let styles = classes
      ? Object.assign({}, defaultStyles, classes)
      : defaultStyles
    const { active } = this.state
    let entities = suggestions.filter(
      s => !blacklist.find(p => p?._id === s._id)
    )
    return (
      <div className={[className, styles.entity_picker].join(' ')}>
        <div className={styles.search_bar}>
          <Icon icon={searchIcon} />
          <input
            ref={this.captureInputElement}
            size={20}
            maxLength={maxLength}
            type="text"
            onFocus={this.setActive}
            onBlur={this.setInactive}
            value={value}
            onChange={this.handleFilterChange}
            placeholder={intl.formatMessage({
              id: pickerInputMessageId || `general.type_to_find_${entityTypeName}`
            })}
          />
        </div>
        {active || alwaysShowEntities ? (
          <div className={styles.pickable_entities}>
            {entities &&
              entities.map(e => {
                let pickable = canPick(e)
                return (
                  <div
                    key={e._id || e}
                    className={
                      pickable
                        ? styles.pickable_entity
                        : styles.unpickable_entity
                    }
                    onMouseDown={PREVENT_DEFAULT}
                    onClick={
                      pickable
                        ? () => {
                            this.handlePickEntity(e)
                          }
                        : undefined
                    }
                  >
                    {renderEntity(e)}
                  </div>
                )
              })}
          </div>
        ) : null}
      </div>
    )
  }
}

export default injectIntl(EntityPicker)
